<!-- 订单管理总页面 -->
<template>
  <div class="app-containers">
    <!--左侧搜索-->
    <div class="top-search order-search">
      <!-- <header v-if="!details" class="search-title">
        <span class="title-text">订单管理</span>
      </header> -->

      <div v-if="!details" class="search-content">
        <div v-if="!isRecycle" style="position: relative;">
          <el-tabs v-model="activeName" @tab-click="handleClick(activeName)">
            <el-tab-pane label="所有订单" name="-1" />
            <el-tab-pane :label="`待付款(${total['0']})`" name="0" />
            <el-tab-pane :label="`待接单(${total['1']})`" name="1" />
            <el-tab-pane :label="`待发货(${total['4']})`" name="3" />
            <el-tab-pane :label="`待收货(${total['5']})`" name="4" />
            <el-tab-pane label="已完成" name="5" />
            <el-tab-pane label="已取消" name="2" />
            <el-tab-pane :label="`售后中(${total['99']})`" name="99" />
            <el-tab-pane label="售后完成" name="100" />
          </el-tabs>
          <span class="recycle" @click="toRecycle(true)">
            <svg-icon class="showIcon" icon-class="recycleBin" />
            <svg-icon class="hoverIcon" icon-class="red-recycleBin" />
            回收站
          </span>
        </div>
        <el-form ref="form" class="commodity-form" :model="sizeForm">
          <div v-if="isRecycle" class="recycleTip">
            <div class="leftIcon"><i class="el-icon-warning" /></div>
            <div class="rightText">
              <p>1.只有已取消和已完成的订单可以删除。</p>
              <p>2.放入回收站的订单，不可再次进行删除，可以再还原到订单列表中。</p>
            </div>
          </div>
          <div class="formtop">
            <el-form-item>
              <el-input v-model="sizeForm.FStockName" suffix-icon="iconfont el-icon-search" placeholder="输入商品名称进行搜索" />
            </el-form-item>
            <el-button class="search-btn" @click="currentPage = 1 , onSearch()">查询</el-button>
            <el-button class="more-search" @click="onTapMoreSearchForm">高级查询<i :class="moreSearch?'el-icon-arrow-up':'el-icon-arrow-down'" /> </el-button>
            <!-- <el-button v-if="isRecycle" class="more-search excelBtn returnOrder" @click="toRecycle(false)">返回</el-button> -->
            <div v-if="isRecycle" style="position:absolute;right:6px;">
              <el-breadcrumb separator="/">

                <span @click="toRecycle(false)"><el-breadcrumb-item to=""><span style="font-weight:bold;cursor: pointer;">订单列表</span>/</el-breadcrumb-item></span>
                <el-breadcrumb-item to=""><span>回收站</span></el-breadcrumb-item>

              </el-breadcrumb>
            </div>

            <!-- <el-button class="more-search excelBtn">订单导出</el-button> -->
          </div>
          <div id="set-input" :class="moreSearch?'more-search-form':'more-search-form-none'">
            <el-row style="width:100%" :gutter="24">
              <el-col :span="6">
                <el-form-item label="订单号：" label-width="85px">
                  <el-input
                    v-model="sizeForm.FOrderNo"
                    placeholder="请输入订单号"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6" :offset="1">
                <el-form-item label="订货编码：" label-width="85px">
                  <el-input
                    v-model="sizeForm.FStockCode"
                    placeholder="请输入订货编码"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6" :offset="1">
                <el-form-item label="需方编码：" label-width="85px">
                  <el-input
                    v-model="sizeForm.FDemandStcokCode"
                    placeholder="请输入需方编码"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6" :offset="1">
                <el-form-item label="下单人：" label-width="85px">
                  <el-input
                    v-model="sizeForm.FUserName"
                    placeholder="请输入下单人"
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row style="width:100%" :gutter="24">
              <el-col :span="6">
                <el-form-item label="收货人：" label-width="85px">
                  <el-input
                    v-model="sizeForm.FReceiver"
                    placeholder="请输入收货人"
                  />
                </el-form-item>
              </el-col>
              <el-col class="depart" :span="6" :offset="1">
                <el-form-item label="下单部门：" label-width="85px">
                  <el-input
                    v-model="sizeForm.FDepartName"
                    placeholder="请选择"
                    clearable
                    @clear="sizeForm.FDepartCode = sizeForm.FDepartName = '',defaultArr = []"
                  >
                    <i slot="suffix" class="el-icon-menu" @click="selectDepart(true)" />
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6" :offset="1">
                <el-form-item label="订单备注：" label-width="85px">
                  <el-input
                    v-model="sizeForm.FOrderRemaker"
                    placeholder="请输入订单备注"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6" :offset="1">
                <el-form-item label="明细备注：" label-width="85px">
                  <el-input
                    v-model="sizeForm.FOrderDRemaker"
                    placeholder="请输入明细备注"
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </el-form>
        <!-- 订单标题头部 -->
        <!-- <div class="order-tab-title">
          <div>商品</div>
          <div>单价</div>
          <div>数量</div>
          <div>商品操作</div>
          <div>订单金额</div>
          <div>订单状态</div>
          <div>订单操作</div>
        </div> -->
        <!-- 订单列表 -->
        <order ref="orderList" :is-recycle="isRecycle" :table-data="tableData" :order-status="orderStatus" @onSearch="onSearch" @onTapOrderDetail="onTapOrderDetail" />
        <div v-if="!tableData || !tableData.length" v-loading="loading" class="noData">
          暂无数据...
        </div>
        <div class="footer-page">
          <el-pagination
            class="commodity-pagination"
            background
            :current-page.sync="currentPage"
            :page-sizes="[15, 50, 100]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pageTotal"
            @size-change="handleSizeChange"
            @current-change="onSearch"
          />
        </div>
      </div>
      <!-- 订单详情 -->
      <detail v-if="details" :fid="fid" @onTapOrderDetail="onTapOrderDetail" />
      <!-- 店铺名称 -->
      <!-- <Store :search-visible="storeVisible" search-url="mall/codeSelect/" title="店铺名称" table-name="mallstore" @cfmSearch="cfmStore" @closeSearch="closeStore" /> -->
      <printOrder
        :change-list="changeList"
        :print-set-dialod="printShow"
        :page-name="'配件返厂'"
        @printOpen="printOpen"
        @printClose="printClose"
      />
      <treeSearch
        ref="depart"
        title="下单部门"
        parent-id="FParentID"
        label="FName"
        fid="FDepartID"
        :tree-visible="departVisible"
        is-check-box
        search-url="/mall/mallmanage/billapprovalinfo/getDemandDepart?type=3"
        :default-arr="defaultArr"
        @treeConfirm="cfmSearch"
        @treeClose="selectDepart"
      />
    </div>
  </div>
</template>

<script>
import Order from './components/order/order.vue'
import Detail from './components/detail/detail.vue'
import printOrder from '../../../components/printSet/printSet.vue'
import { orderQuery, selectPrintTemplate } from '@/api/order.js'
import treeSearch from '@/components/tree/tree.vue'
export default {
  components: { Order, Detail, printOrder, treeSearch },

  data() {
    return {
      isRecycle: false,
      loading: false,
      defaultArr: [],
      departVisible: false,
      printShow: false,
      changeList: {
        setprinTtable: [{
          hastip: true,
          isHave: false,
          propdata: 'outWarehouseName',
          title: '订单号'
        }]
      },
      pageTotal: 0,
      currentPage: 1,
      pageSize: 15,
      storeVisible: false,
      sizeForm: {
        ForderType: -1,
        FOrderNo: '',
        FStockName: '',
        FStockCode: '',
        FUserName: '',
        FReceiver: '',
        FOrderRemaker: '',
        FOrderDRemaker: '',
        FDemandStcokCode: '',
        FDepartCode: '',
        FDepartName: '',
        beginTime: null,
        endTime: null,
        FstoreName: '',
        FAfterSales: '-1',
        FInvoiceStatus: '-1',
        fDetailRemark: '',
        FDeleted: 0
      },
      moreSearch: false,
      activeName: '-1',
      orderStatus: '-1',
      details: false,
      tableData: [],
      total: {
        1: 0,
        0: 0,
        4: 0,
        5: 0,
        99: 0
      },
      fid: null,
      detailList: [],
      orderInfo: {},
      options: []
    }
  },
  created() {
    this.$nextTick(() => {
      if (this.$route.query.FBillID) {
        this.$refs.orderList.onTapOrderDetail(this.$route.query.FBillID)
      }
      if (this.$route.query.id) {
        this.fid = this.$route.query.id
        this.details = this.$route.query.details
      }
    })

    if (this.$route.params.orderStatus) {
      this.activeName = this.orderStatus = this.$route.params.orderStatus
      this.sizeForm.ForderType = Number(this.$route.params.orderStatus)
    }
    this.onSearch()
    this.getPrintTemplate()
  },
  methods: {
    toRecycle(b) {
      this.isRecycle = b
      this.currentPage = 1
      this.sizeForm.FDeleted = Number(b)
      this.sizeForm.ForderType = b ? -2 : -1
      this.onSearch()
    },
    getRecycle() {

    },
    cfmSearch() {
      const arr = this.$refs.depart.getValue()
      const codes = []
      const names = []
      this.defaultArr = []
      arr.forEach(t => {
        codes.push(t.FTreeCode)
        names.push(t.FName)
        this.defaultArr.push(t.fid)
      })
      this.sizeForm.FDepartCode = codes.toString()
      this.sizeForm.FDepartName = names.toString()
      this.selectDepart(false)
    },
    selectDepart(b) {
      this.departVisible = b
    },
    getPrintTemplate() {
      const params = new URLSearchParams()
      params.append('menuPageName', '需方订单管理')
      selectPrintTemplate(params)
        .then(res => {
        //   console.log(res)
        })
    },
    printOpens() {
      this.printShow = true
    },
    printOpen() {

    },
    printClose() {
      this.printShow = false
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.onSearch()
    },
    clearStore() {
      this.sizeForm.FstoreName = ''
      this.sizeForm.FstoreID = null
    },
    cfmStore(val) {
      this.sizeForm.FstoreID = val ? val.fid : null
      this.sizeForm.FstoreName = val ? val.fname : ''
      this.storeVisible = false
    },
    closeStore() {
      this.storeVisible = false
    },
    onSearch() {
      this.tableData = []
      this.loading = true
      const params = new URLSearchParams()
      const jsonobj = JSON.parse(JSON.stringify(this.sizeForm))
      jsonobj.FAfterSales = Number(jsonobj.FAfterSales)
      jsonobj.FInvoiceStatus = Number(jsonobj.FInvoiceStatus)
      params.append('jsonobj', JSON.stringify(jsonobj))
      params.append('pageNo', this.currentPage)
      params.append('pageSize', this.pageSize)
      orderQuery(params)
        .then(res => {
          this.loading = false
          if (res.result) {
            this.pageTotal = res.data.datas.total
            res.data.datas.records.forEach(item => {
              if (item.fdetails.length) {
                item.fdetails.unshift({
                  row: true
                })
              }
              item['afterList'] = []
              item.fdetails.forEach(t => {
                if (!t.row && ((t.FQuanty - t.FApplyReturnQuanty - t.FReturnQuanty) > 0)) item.afterList.push(t)
              })
            })
            this.tableData = []
            this.tableData = res.data.datas.records
            this.total['1'] = res.data.sums.records[0].freceived
            this.total['0'] = res.data.sums.records[0].fchecked
            this.total['4'] = res.data.sums.records[0].fsended
            this.total['5'] = res.data.sums.records[0].freved
            this.total['99'] = res.data.sums.records[0].fafterSalesIng
          } else {
            this.$message.error(res.msg)
          }
        })
        .catch(() => {
          this.loading = false
        })
    },
    onTapMoreSearchForm() {
      this.moreSearch = !this.moreSearch
    },
    handleClick(e) {
      this.sizeForm.ForderType = Number(e)
      this.orderStatus = e
      this.sizeForm.ForderNo = this.sizeForm.beginTime = this.endTime = null
      this.sizeForm.FstoreName = ''
      this.sizeForm.FAfterSales = this.sizeForm.FInvoiceStatus = '-1'
      this.currentPage = 1
      this.onSearch()
    },
    // 监听是否显示详情
    onTapOrderDetail(details, id) {
    //   console.log('监听是否显示详情', details)
      if (details) {
        const path = this.$router.resolve({
          path: '/order/orderManagement',
          query: {
            id,
            details
          }
        })
        window.open(path.href, '_blank')
      } else {
        this.fid = id
        this.details = details
      }
    }

  }
}
</script>

<style lang="scss">
.search-content {
    .el-tabs {
        background-color: #fff;
    }
    .el-input__inner {
        height: 36px;
    }
    .el-tabs__header {
        margin: 0;
    }

    .recycle {
        cursor: pointer;
        position: absolute;
        right: 28px;
        top: 50%;
        transform: translateY(-50%);
        color: #333;
        .hoverIcon {
            display: none;
        }
        .svg-icon {
            margin-right: 7px;
        }
        &:hover {
            color: #EC212D;
            .hoverIcon {
                display: inline-block;
            }
            .showIcon {
                display: none;
            }
        }
    }
}
.app-containers{
  background: #F5F5F5;
//   padding: 8px;
  height: 100%;
  display: flex;
  flex-direction: column;
//   overflow: scroll;
  .footer-page {
      overflow: hidden;
      margin: 15px 0 10px;
      .el-pagination {
          float: right;
          margin-right: 20px;
          .el-pager {
              .number {
                  border: 1px solid #DCDCDC;
                  background-color: #fff;
                  color: #000000;
              }
              .active {
                  border-color: #EC212D;
              }
          }
      }
      .el-input__inner {
          height: 28px;
      }

  }
  .timeClear .el-input__suffix {
      right: 22px;
      top: 1px;
  }
   .search-title{
    display: flex;
    justify-content: space-between;
    width:100%;
    height: 36px;
    line-height: 36px;
    background-color: #EC212D;
    .title-text{
      color:#fff;
      font-size: 16px;
      margin-left: 11px;
    }
  }
  .el-tabs__item{
    // width: 132px;
    min-width: 100px;
    padding: 0;
    height: 60px;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 500;
    // color: #666666;
    line-height: 60px;
    text-align: center;
  }
  .noData {
      background-color: #fff;
      height: 65vh;
      line-height: 65vh;
      text-align: center;
      .el-loading-spinner {
          margin-top: 0;
          top: 0;
      }
  }
  .commodity-form{
    display: flex;
    flex-direction: column;
    margin: 10px 0px;
    min-height: 50px;
    background: #fff;
    box-sizing: border-box;
    padding: 15px;
        .recycleTip {
            display: flex;
            height: 76px;
            border: 1px solid #F9B464;
            margin-bottom: 16px;
            border-radius: 4px;
            background-color: #FFF5E7;
            .leftIcon {
                margin-left: 32px;
                margin-right: 22px;
                line-height: 74px;
                i {
                    font-size: 20px;
                    color: #F79118;
                }
            }
            .rightText {
                padding: 15px 0;
                p {
                    font-size: 14px;
                    color: #333;
                    &:first-child {
                        margin-bottom: 6px;
                    }
                }
            }
        }
    .formtop{
        position: relative;
      width: 100%;
      height: 40px;
      display: flex;
      align-items: center;

      .el-form-item{
        margin-bottom: 0;
      }
      .el-input{
      width: 290px;
      margin-right: 11px;
       }
      .search-btn{
        width: 69px;
        height: 36px !important;
        background: #EC212D;
        border-radius: 4px;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 12px;
        font-size: 16px;
        font-weight: 400;
        color: #FFFFFF;
      }
      .more-search{
           width: 100px;
          height: 36px;
          background: #FFFFFF;
          box-shadow: 0px 0px 8px 0px rgba(152, 152, 152, 0.2);
          border: 1px solid #ececec;
          border-radius: 5px;
          font-size: 16px;
          font-weight: 400;
          color: #666666;
           display: flex;
          align-items: center;
          justify-content: center;
      }
      .excelBtn {
          border-color: #333333;
          position: absolute;
          right: 6px;
      }
        .returnOrder {
          right: 15px;
      }
    }

    .more-search-form{
      width: 100%;
      padding-top: 15px;
      margin-top: 15px;
      background-color: #f5f5f5;
      .depart {
          .el-input__suffix {
              right: 10px;
          }
      }
      .el-form-item__label {
          font-size: 12px;
          font-weight: 400;
          color: #666;
      }
      .el-form-item{
        margin-bottom: 15px;
      }
    }
    .more-search-form-none{
      display: none;
    }

  }

  .order-tab-title{
    width: 100%;
    height: 32px;
    background: #F5F5F5;
    border-radius: 5px;
    margin: 5px 0px;
    display: flex;
    align-items: center;
    // overflow: scroll;
    div{
      width: 30%;
      text-align: center;
      font-size: 14px;
      font-family: SimSun;
      font-weight: 400;
      color: #666666;
    }
  }
  .order-tab-title div:first-child{
      min-width: 40%;
       text-align: center;
  }
/* 日期选择器-图标右移 */
          .date-picker-icon {
            width: 100%;
            .el-input__inner {
                height: 36px !important;
                padding-left: 15px;
                padding-right: 30px;
            }

            .el-input__prefix {
              left: initial;
              right: 5px;
            }
            &.date-close {
              .el-icon-date {
                display: none;
              }
            }
          }
}

#set-input{
  .el-form-item__label{
    padding-right: 4px;
    flex: none;
    width:auto  !important;
    width: 78px !important;
  }
  .el-form-item{
    display: flex;
  }
  .el-form-item__content{
    margin-left: 0 !important;
    margin-right: 0;
    max-width: 240px;
  }
  .el-col{
    margin-left: 0;
  }
  .el-row{
    margin-left: 0 !important;
  }
  .el-input__inner{
    padding-right: 15px;
  }
}
</style>
